import { BarChart } from '@/components/ui/bar-chart.tsx';
import { Card, CardContent } from '@/components/ui/card';

interface WeeklyRecord {
  day: string;
  income: number;
}

interface WeeklyPerformanceChartProps {
  data: WeeklyRecord[];
  title?: string;
  className?: string;
}

export const WeeklyPerformanceChart = ({
  data,
  title = 'Weekly Performance',
  className = '',
}: WeeklyPerformanceChartProps) => {
  const chartData = data.map(record => ({
    name: record.day,
    total: record.income,
  }));

  return (
    <Card className={className}>
      <CardContent className="pt-6">
        <h3 className="text-lg font-semibold mb-4">{title}</h3>
        <div className="h-[300px] w-full">
          <BarChart
            data={chartData}
            index="name"
            categories={['total']}
            colors={['#0ea5e9']}
            valueFormatter={value =>
              value.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })
            }
          />
        </div>
      </CardContent>
    </Card>
  );
};
